import { Dialog, DialogActions, DialogContent } from '@mui/material';
import React, { useState } from 'react';
import { RiQuestionLine } from 'react-icons/ri';
import { Button } from './Ui';

const ConfirmationModal = ({
  modalOpen,
  setModalOpen,
  title,
  description,
  modalIcon,
  modalWidth = '500px',
  accent = 'primary',
  onSubmit,
  onClose,
}) => {
  const [isSubmiting, setIsSubmiting] = useState(false);
  const handleClose = () => {
    if (isSubmiting) return;
    setModalOpen(false);
    onClose?.();
  };
  const handleSubmitWithLoading = async () => {
    if (isSubmiting) return;
    setIsSubmiting(true);
    await onSubmit?.();
    setIsSubmiting(false);
    setModalOpen(false);
  };
  return (
    <div>
      <Dialog
        open={modalOpen}
        onClose={(_, reason) => {
          if (reason === 'backdropClick') return;
          handleClose();
        }}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: 460,
            maxWidth: 'calc(100% - 32px)',
            borderRadius: '12px',
          },
        }}
      >
        <DialogContent>
          <div className="flex gap-3">
            {modalIcon || (
              <RiQuestionLine
                size={22}
                className={`mt-0.5 shrink-0 text-${accent}-600`}
              />
            )}
            <div className="space-y-2">
              <h2 className="text-lg font-bold text-gray-800">
                {title || 'Are You sure'}
              </h2>
              <p className="text-sm text-gray-500">
                {description || 'Are you sure you want to continue?'}
              </p>
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            variant="outlined"
            intent="default"
            onClick={handleClose}
            disabled={isSubmiting}
          >
            Cancel
          </Button>
          <Button
            intent={accent}
            onClick={handleSubmitWithLoading}
            disabled={isSubmiting}
          >
            {isSubmiting ? 'Updating…' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmationModal;
